<template>
  <div id="app">
    <router-view/>
    <div class="spinner">
    <div class="rect1"></div>
    <div class="rect2"></div>
    <div class="rect3"></div>
    <div class="rect4"></div>
    <div class="rect5"></div>
</div>
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted(){
   
    let path = this.$route.path
    let url=window.location.href
    console.log(path)
    console.log(url)
    if(url.includes('www.medcircle.cn')){
      console.log(1)
     location.href = `http://www.medcircle.cn/meetingapp${path}`;//生产环境
    }else if (url.includes('www.medcircle.top')){
      console.log(2)
       location.href = `http://www.medcircle.top/meetingapp${path}`;//测试环境
    }

 
     
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  position: relative;
  margin: 0 ;
  padding: 0;
  width: 100%;
  height: 100%;
}
.spinner {
  /* height: 100%; */
  /* margin: 0 auto; */
    position: absolute;

  width: 50px;
  top: 50%;
  left: 50%;
  margin-top: -30px;
  margin-left: -30px;
  height: 60px;
  text-align: center;
  font-size: 10px;
}
 
.spinner > div {
  background-color: #67CF22;
  height: 100%;
  width: 6px;
  display: inline-block;
   
  -webkit-animation: stretchdelay 1.2s infinite ease-in-out;
  animation: stretchdelay 1.2s infinite ease-in-out;
}
 
.spinner .rect2 {
  -webkit-animation-delay: -1.1s;
  animation-delay: -1.1s;
}
 
.spinner .rect3 {
  -webkit-animation-delay: -1.0s;
  animation-delay: -1.0s;
}
 
.spinner .rect4 {
  -webkit-animation-delay: -0.9s;
  animation-delay: -0.9s;
}
 
.spinner .rect5 {
  -webkit-animation-delay: -0.8s;
  animation-delay: -0.8s;
}
 
@-webkit-keyframes stretchdelay {
  0%, 40%, 100% { -webkit-transform: scaleY(0.4) } 
  20% { -webkit-transform: scaleY(1.0) }
}
 
@keyframes stretchdelay {
  0%, 40%, 100% {
    transform: scaleY(0.4);
    -webkit-transform: scaleY(0.4);
  }  20% {
    transform: scaleY(1.0);
    -webkit-transform: scaleY(1.0);
  }
}


</style>



// WEBPACK FOOTER //
// src/App.vue